import React from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import styles from "assets/jss/vivoleo-react-kit/views/components.js";
import Header from "components/Header/Header.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
import SectionAboutUs from "views/Components/Sections/SectionAboutUs";
import HeaderLinks from "components/Header/HeaderLinks.js";

const useStyles = makeStyles(styles);

export default function FinanceHomeScreen(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const { t } = useTranslation();
  return (
    <div>
      <Parallax
        homePageFilter
        image={require("assets/img/homepage/3H21KUXVT4.jpg").default}
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>{t("homePage.title")}</h1>
                <div className={classes.space30}></div>
                <div className={classes.subtitle}>
                  <Button
                    className={classes.btnColor}
                    round
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById("contactus").scrollIntoView();
                    }}
                  >
                    {t("contact.contactus")}
                  </Button>
                </div>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <SectionAboutUs />
    </div>
  );
}
